import { Lightning } from "@lightningjs/sdk";

class LoggerService extends Lightning.EventEmitter {
  log(logString) {
    this.emit("log_data", { log: logString });
  }
}

export default new LoggerService();
